/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1ExamRevisionLangBotexamlangidMutationRequest,
  PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
  PutApiV1ExamRevisionLangBotexamlangidPathParams,
  PutApiV1ExamRevisionLangBotexamlangid400,
  PutApiV1ExamRevisionLangBotexamlangid401,
  PutApiV1ExamRevisionLangBotexamlangid404,
  PutApiV1ExamRevisionLangBotexamlangid500,
} from "../../types/examRevisionController/PutApiV1ExamRevisionLangBotexamlangid.ts";

function getPutApiV1ExamRevisionLangBotexamlangidUrl(
  botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/exam/revision/lang/${botExamLangId}` as const,
  };
  return res;
}

/**
 * @description Atualiza os dados (cultura, título, instrução e situação) de um idioma existente (ClassroomDisciplineBotExamLang). Valida que o código de cultura é permitido pelo sistema e que, caso a cultura seja alterada, não existe outro registro com a mesma combinação BotExamId + CultureInfo. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma de prova gerada por IA (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId}
 */
export async function putApiV1ExamRevisionLangBotexamlangid(
  botExamLangId: PutApiV1ExamRevisionLangBotexamlangidPathParams["botExamLangId"],
  data?: PutApiV1ExamRevisionLangBotexamlangidMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1ExamRevisionLangBotexamlangidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1ExamRevisionLangBotexamlangidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamRevisionLangBotexamlangid400
      | PutApiV1ExamRevisionLangBotexamlangid401
      | PutApiV1ExamRevisionLangBotexamlangid404
      | PutApiV1ExamRevisionLangBotexamlangid500
    >,
    PutApiV1ExamRevisionLangBotexamlangidMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1ExamRevisionLangBotexamlangidUrl(
      botExamLangId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
